var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 40 40" }, props),
    React.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M31 22.7c-1.4-2.4-.5-5.4 1.8-6.8l-2.6-4.4c-.7.4-1.6.7-2.5.7-2.7 0-5-.9-5-4.9h-5.1c0 1-.2 1.6-.7 2.4-1.4 2.4-4.4 3.1-6.8 1.8l-2.6 4.4c.7.4 1.4 1 1.8 1.8 1.4 2.4.5 5.4-1.8 6.8l2.6 4.4c.7-.4 1.6-.6 2.5-.6 2.7 0 4.9 3 5 5h5.1c0-1 .2-1.7.7-2.5 1.4-2.4 4.4-3.2 6.8-1.8l2.6-4.4c-.7-.5-1.3-1.1-1.8-1.9zm-10.7 2.7c-2.9 0-5.3-2.4-5.3-5.3s2.4-5.3 5.3-5.3 5.3 2.4 5.3 5.3-2.4 5.3-5.3 5.3z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/products/Settings.svg